export default __webpack_public_path__ + "static/image157-daf1400817206aa6e9eee603bb2c375b.jpg";